'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var localCache = require('./localCache.js');
var localStore = require('./localStore.js');
var sessionCache = require('./sessionCache.js');
var sessionStore = require('./sessionStore.js');
var memoryStorage = require('./memoryStorage.js');
require('./tslib.es6-cd939937.js');
require('./_storageService-be0124c8.js');



exports.LocalCache = localCache.LocalCache;
exports.localCache = localCache.localCache;
exports.LocalStore = localStore.LocalStore;
exports.localStore = localStore.localStore;
exports.SessionCache = sessionCache.SessionCache;
exports.sessionCache = sessionCache.sessionCache;
exports.SessionStore = sessionStore.SessionStore;
exports.sessionStore = sessionStore.sessionStore;
exports.MemoryStorage = memoryStorage.MemoryStorage;
